import httpClient from '../httpClient';

export async function getAllSesUsuario() {
  try {
    const response = await httpClient.get(`/api/sesusuario`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de SESUSUARIO: ' + error);
  }
}

export async function getSesUsuario(sesusuarioID: string) {
  try {
    const response = await httpClient.get(`/api/sesusuario/${sesusuarioID}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter SESUSUARIO: ' + error);
  }
}

export async function getSesUsuariosBySesId(sesId: string) {
  try {
    const response = await httpClient.get(`/api/sesusuario/ses/${sesId}`);
    console.log(response);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Usuários da SES: ' + error);
  }
}
